import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    borderRadius: 8,
    background: theme.palette.grey[200],
    margin: ' 8px 0 16px 0',
    [theme.breakpoints.down('sm')]: {
      marginTop: -20
    }
  },
  topHeader: { padding: 16 },
  middle: { padding: '8px 16px', display: 'flex', flexDirection: 'column' },
  bottom: { padding: '8px 16px' },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  roomTitle: {
    fontWeight: 600,
    fontSize: 14,
    color: theme.palette.text.primary
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '9fr 4fr',
    gap: 4
  },
  greenText: {
    color: theme.palette.secondary.main,
    fontWeight: 600,
    textAlign: 'right'
  },
  greyText: { fontWeight: 600, color: theme.palette.grey[700] },
  darkText: {
    fontWeight: 600,
    color: theme.palette.grey[800],
    textAlign: 'right'
  },
  boldTotal: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  section: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  tooltipIcon: {
    fontSize: 12,
    verticalAlign: 'middle',
    marginLeft: 4,
    color: theme.palette.grey[600]
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.background.default,
    padding: 8,
    width: 250,
    direction: 'ltr'
  },
  header: { padding: 5 },
  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: '2px',
    gap: 4
  },
  toolTipText: { fontWeight: 600, color: theme.palette.text.primary },
  total: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: theme.palette.grey[200],
    marginTop: 6,
    padding: 5
  },
  dateDetails: {
    display: 'flex',
    alignItems: 'space-between',
    flexDirection: 'column',
    justifyContent: 'space-between',
    background: theme.palette.grey[100],
    padding: 4,
    marginTop: 3
  },
  toolTip: { padding: 8, background: theme.palette.grey[100] },
  arrow: { color: theme.palette.grey[100] },
  info: { lineHeight: '18px' }
}))
export default useStyles
